export default {
  namespaced: true,
  state: () => ({
    message: null,
    value: null,
    type: 'info'
  }),
  getters: {
    message: state => state.message,
    value: state => state.value,
    type: state => state.type
  },
  mutations: {
    setAlert (state, { message, value, type }) {
      state.message = message
      state.value = value
      state.type = type
    },
    setError (state, error) {
      state.type = 'danger'
      if (!error) {
        return
      }
      let err = null
      if (error.response && error.response.data) {
        err = error.response.data
      }
      if (err) {
        if (err.errors && err.errors.length > 0) {
          console.error('------>', err)
          // state.value = err.errors
        } else if (err.message) {
          console.error('------>', err)
          // state.message = err.message
        } else {
          console.error('------>', err)
        }
      } else {
        console.error('------>', err)
      }
    },
    reset (state) {
      state.message = null
      state.value = null
      state.type = 'info'
    }
  }
}
